<proffeo-ui-dialog [title]="'files.explorer.move' | translate">
  <proffeo-file-explorer
    (folderSelected)="selectFolder($event)"
    [context]="data.context"
    [selectionMode]="true"
  />
</proffeo-ui-dialog>
